import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ dataProcessId = '', ...params }) => {
  return await dponetAPI.get(`/data_processes/${dataProcessId}`, { params })
}

const getWithLiaAnswers = async ({ ...params }) => {
  return await dponetAPI.get(`/data_processes/list_with_lia_answers`, {
    params,
  })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('/data_processes', data)
}

const put = async ({ dataProcessId = '', ...data }) => {
  return await dponetAPI.put(`/data_processes/${dataProcessId}`, data)
}

const getRelationOptions = async ({ ...params }) => {
  return await dponetAPI.get(`/data_processes/relations_options`, { params })
}

const changeStatus = async ({
  dataProcessId,
  statusId,
  adoptedMatrixRiskId,
}) => {
  return await dponetAPI.put(
    `/data_processes/${dataProcessId}/change_status/${statusId}`,
    { dataProcess: { adoptedMatrixRiskId } },
  )
}

const reopen = async ({ dataProcessId }, data) => {
  return await dponetAPI.post(`/data_processes/${dataProcessId}/reopen`, data)
}

const logs = async ({ dataProcessId }) => {
  return await dponetAPI.get(`/data_processes/${dataProcessId}/logs`)
}

const softDelete = async ({ dataProcessId, ...params }) => {
  return await dponetAPI.delete(
    `/data_processes/${dataProcessId}/soft_delete`,
    { params },
  )
}

const copy = async ({ dataProcessId, ...params }) => {
  return await dponetAPI.post(`/data_processes/${dataProcessId}/copy`, params)
}

const discard = async ({ dataProcessId, ...params }) => {
  return await dponetAPI.post(
    `/data_processes/${dataProcessId}/discard`,
    params,
  )
}

const suggested = async ({ dataProcessId = '', ...params }) => {
  return await dponetAPI.get(`/data_processes/suggestions/${dataProcessId}`, {
    params,
  })
}

const totalSuggested = async ({ ...params }) => {
  return await dponetAPI.get(`/data_processes/total_suggestions`, { params })
}

const discarded = async ({ ...params }) => {
  return await dponetAPI.get(
    `/data_processes/suggestions?suggested_data_processes_status=3`,
    { params },
  )
}

const acceptSuggestion = async ({ dataProcessId, ...params }) => {
  return await dponetAPI.post(
    `/data_processes/${dataProcessId}/suggestions/accept`,
    params,
  )
}

const refuseSuggestion = async ({ dataProcessId, ...params }) => {
  return await dponetAPI.post(
    `/data_processes/${dataProcessId}/suggestions/refuse`,
    { params },
  )
}

const destroyDataProcessDataSource = async ({
  dataProcessId,
  dataProcessDataSourceId,
  ...params
}) => {
  return await dponetAPI.delete(
    `/data_processes/${dataProcessId}/data_process_data_sources/${dataProcessDataSourceId}`,
    { params },
  )
}

const unnecessaryData = async ({ dataProcessId, ...data }) => {
  return await dponetAPI.put(
    `/data_processes/${dataProcessId}/update_unnecessary_data`,
    data,
  )
}

const suggestedMatrixRisk = async ({ dataProcessId }) => {
  return await dponetAPI.get(
    `/data_processes/${dataProcessId}/suggested_matrix_risk`,
  )
}

const sourceOptions = async () => {
  return await dponetAPI.get('source_options')
}

const revertLia = async ({ dataProcessId, ...data }) => {
  return await dponetAPI.post(
    `/data_processes/${dataProcessId}/legitimate_interest/revert`,
    {
      ...data,
    },
  )
}

const getProcessResponsibles = async ({ dataProcessId }) => {
  return await dponetAPI.get(
    `/data_processes/${dataProcessId}/data_process_responsibles`,
  )
}

const createProcessResponsibles = async ({ dataProcessId, ...data }) => {
  return await dponetAPI.post(
    `/data_processes/${dataProcessId}/data_process_responsibles`,
    data,
  )
}

const updateProcessResponsibles = async ({ dataProcessId, ...data }) => {
  return await dponetAPI.put(
    `/data_processes/${dataProcessId}/data_process_responsibles`,
    data,
  )
}

const addLinkedDocument = async ({ dataProcessId, ...data }) => {
  return await dponetAPI.post(
    `/data_processes/${dataProcessId}/linked_documents`,
    data,
  )
}

const removeLinkedDocument = async ({ dataProcessId, documentId }) => {
  return await dponetAPI.delete(
    `/data_processes/${dataProcessId}/linked_documents/${documentId}`,
  )
}

export default {
  acceptSuggestion,
  addLinkedDocument,
  changeStatus,
  copy,
  create,
  createProcessResponsibles,
  destroyDataProcessDataSource,
  discard,
  discarded,
  get,
  getProcessResponsibles,
  getRelationOptions,
  getWithLiaAnswers,
  logs,
  put,
  refuseSuggestion,
  removeLinkedDocument,
  reopen,
  revertLia,
  softDelete,
  sourceOptions,
  suggested,
  suggestedMatrixRisk,
  totalSuggested,
  unnecessaryData,
  updateProcessResponsibles,
}
